import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class ButtonComponent implements OnInit, OnChanges{
  @Input({ required: true }) bgColor!: string;
  @Input() radius?: string;
  @Input() border?: boolean;
  @Input() disabled?: boolean;
  @Input() borderColor?: string;
  @Input() borderPadding?: string;

  @Output() clicked = new EventEmitter<boolean>();

  buttonStyle: any = {};
  borderStyle: any = {};

  ngOnInit(): void {
    this.getStyles();
  }

  click(){
    this.clicked.emit(true)
  }

  ngOnChanges(changes: any): void {
    this.getStyles();
    if (changes.bgColor?.currentValue) {
      this.buttonStyle['background-color'] = changes.bgColor.currentValue;
    }

    if (changes.radius?.currentValue) {
      this.buttonStyle.borderRadius = this.border || changes.border.currentValue ? `calc(${changes.radius.currentValue} / 2)` : changes.radius.currentValue;
    }

    if (changes.border?.currentValue && (changes.borderColor?.currentValue || this.borderColor)) {
      const color = changes.borderColor?.currentValue || this.borderColor;
      this.borderStyle['border'] = `1px solid ${color}`;
    }

    if (changes.disabled?.currentValue) {
      this.borderStyle.opacity = changes.disabled.currentValue ? 0.7 : 1;
    }

    if (changes.borderPadding?.currentValue) {
      this.borderStyle.padding = (changes.borderPadding?.currentValue && changes.borderPadding?.currentValue) !== '' ? this.borderPadding : '4px';
    }
  }

  getStyles(){
    this.buttonStyle['background'] = this.bgColor;
    this.buttonStyle.borderRadius = this.border ? `calc(${this.radius} / 2)` : this.radius;
    this.borderStyle.border = this.border ? `1px solid ${this.borderColor}` : 'none';
    this.borderStyle.borderRadius = this.radius;
    this.borderStyle.opacity = this.disabled ? 0.7 : 1;
    this.borderStyle.padding = (this.borderPadding && this.borderPadding !== '') ? this.borderPadding : '4px';
  }
}
